import { RegisterApiClient } from "@/features/register/api-client/api-client";
import type { CheckEmailResponse } from "@/features/register/types";
import useCaptchaVerify from "@/features/utils/hooks/use_captcha_verify";
import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export default function useCheckEmailMutation(
  options?: UseMutationOptions<CheckEmailResponse, Error, string>
) {
  const { t } = useTranslation(["pass"]);

  const { handleReCaptchaVerify } = useCaptchaVerify();

  return useMutation<CheckEmailResponse, Error, string>({
    mutationFn: async (email: string) => {
      const token = await handleReCaptchaVerify();

      // @TODO detect language correctly
      const data = await RegisterApiClient.checkEmail({
        email,
        captcha_token: token,
        language: "fr"
      });
      if (data.code && data.code === 429)
        throw new Error(t("flow.id_control.error.check_email_rate_limit"));

      if (!data.success && !data.code) {
        throw new Error(t("flow.id_control.error.check_email"));
      }

      return data;
    },
    ...options
  });
}
